import React from 'react'

import { ZariContext } from '_zari/context'

import { Form, Button } from '_zari/core'

import { NuevaDireccionModal } from 'sharedComponents/modals'

import * as SocioCrud from 'services/socio.service'

const DireccionSocioFormGroup = ({ disabled, showNewButton, idSocio, oneRowTrigger, onCreate, ...props }) => {
  const __zariContext = React.useContext(ZariContext)

  const [direcciones, setDirecciones] = React.useState([])
  const [mostrarNuevaDireccionModal, setMostrarNuevaDireccionModal] = React.useState(false)

  React.useEffect(() => {
    if (idSocio) {
      SocioCrud.obtenerDireccionesxIdSocioAsSelect(idSocio)
        .then(({ data }) => {
          setDirecciones(data)
          if (data && data.length === 1) {
            oneRowTrigger(data[0])
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setDirecciones([])
    }
  }, [idSocio, __zariContext, oneRowTrigger])

  const clickMostrarModal = React.useCallback(() => {
    setMostrarNuevaDireccionModal(true)
  }, [])

  const innerOnCreate = React.useCallback(
    creationResult => {
      onCreate(
        creationResult,
        () => setMostrarNuevaDireccionModal(false),
        () =>
          SocioCrud.obtenerDireccionesxIdSocioAsSelect(idSocio)
            .then(({ data }) => {
              setDirecciones(data)
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
      )
    },
    [onCreate, idSocio, __zariContext]
  )

  return (
    <>
      {showNewButton ? (
        <Form.InputGroup>
          <Form.Select {...props} disabled={disabled}>
            <option value=''>Seleccionar</option>
            {direcciones.map((val, key) => (
              <option key={key} value={val._id}>
                {val.direccion}
              </option>
            ))}
          </Form.Select>
          <Form.InputGroup.Append>
            <Button disabled={disabled} onClick={clickMostrarModal}>
              &#x2b;
            </Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
      ) : (
        <></>
      )}
      {mostrarNuevaDireccionModal && (
        <NuevaDireccionModal
          handleClose={e => setMostrarNuevaDireccionModal(false)}
          show={mostrarNuevaDireccionModal}
          idSocio={idSocio}
          onCreate={innerOnCreate}
        />
      )}
    </>
  )
}

export default React.memo(DireccionSocioFormGroup)
